import React from 'react';
import { connect } from 'react-redux';
import Modal, {isOpened} from "../layout/Modal"
import { closeModal } from '../../actions';

class MainModal extends React.Component {

	render() {
		return isOpened(this.props.config.state) && <Modal
			{...this.props.config}
			timeout={this.props.config.timeout}
			buttons={this.props.config.buttons || [
				{text: 'Ok', onClose: true, onClick: () => {
					this.props.closeModal({});
				}}
			]}
		>{ this.props.config.text ? <p>{this.props.config.text}</p> : this.props.config.body }</Modal>;
	}
}

export default connect(
	(state) =>{
		return {
			config: state.app.modal
		};
	},
	{
		closeModal
	}
)(MainModal);